import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {KnowledgeArticleStartDto} from "@server-models";
import {select, Store} from "@ngrx/store";
import {SharedKnowledgeState} from "../store/knowledge.state";
import {inject} from "@angular/core";
import {filter, take, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {SharedKnowledgeSelectors} from "../store/knowledge.selectors-type";
import {SharedKnowledgeActions} from "../store/knowledge.actions-type";


export const sharedKnowledgeArticleDetailResolver: ResolveFn<KnowledgeArticleStartDto | null | undefined> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store: Store<SharedKnowledgeState> = inject(Store);
    const currentId: string = route.paramMap.get('articleId')!;
    store.dispatch((SharedKnowledgeActions.getArticlePage({
      articleId: parseInt(currentId)
    })));

    return store.pipe(
      select(SharedKnowledgeSelectors.selectArticlePage),
      withLatestFrom(store.pipe(select(SharedKnowledgeSelectors.selectKnowledgePathLoading))),
      filter(([data, loading]) => !!data && !loading),
      take(1),
      map(([data]) => data)
    );
  };
